export default __webpack_public_path__ + "static/anti-wildlife-wall-589f1b1c0f0bbf501ed34a99158fe5c1.jpg";